<template>
  <div style="width:100%;height:auto; margin:0 auto;">
    <div class="filter-container">
      <el-date-picker
        v-model="queryPage.itemTime"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-button class="filter-item" :disabled="queryPage.itemTime.length !== 2" style="margin-left:10px" icon="el-icon-search" type="primary" @click="getDetailed()">查询</el-button>
      <el-button class="filter-item" :disabled="location.length === 0" type="primary" icon="el-icon-video-play" @click="startAnimation">开始回放</el-button>
    </div>
    
    <mav-container ref="MavContainer" :visable="visableMapEdit" :paths="location" :pagekey="pagekey" ></mav-container>
    <span slot="footer" class="dialog-footer">
      <div style="text-align:center;">
        <el-button type="danger" @click="closePage()">关闭</el-button>
      </div>
    </span>
  </div>
</template>

<script>
import MavContainer from "@/components/map/amap"
import { getLocations as getInfo } from '@/api/epvVehicle'

export default {
  inject: ['getList'],
  components: { MavContainer },
  props: { // 第二种方式
    proid: { // 车牌号
      type: String,
      required: true
    }
  },
  data() {
    return {
      pagekey: '3', // 轨迹回放
      visableMapEdit: '2', // 地图内容是否可编辑
      form: {},
      location: [],
      queryPage: {
        name: this.proid,
        itemTime: []
      }
    }
  },
  created() {
  },
  methods: {
    startAnimation(){
      this.$refs.MavContainer.startAnimation()
    },
    // 获取明细数据
    getDetailed() {
      this.location = []
      var that =this
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
          this.$refs.MavContainer.deleMap()
      getInfo(this.queryPage).then(response => {
        this.form = response.data
        if (response.data.length>0) {
          response.data.forEach(v => {
            this.location.push([v.lng, v.lat])
          });
        }
        if (this.location.length > 0) {
          this.$refs.MavContainer.load2DMap(this.location)
        } else {
          this.$message.warning('当前车辆在此时间范围内没有运行轨迹!')
        }
        loading.close()
      }).catch(function() {
        loading.close()
      })
    },
    closePage() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
